// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__q5ika","inner":"Footer_inner__3hHEw"};